import { ValidatorFn } from '@angular/forms';

export interface BaseControlInterface<T> {
  display_name: string;
  placeholder?: string;
  field_name: string;
  validators: ValidatorFn[];
  input_type: ControlTypeEnum;
  default_value?: T;
  description?: string;
  errorDisplays?: Record<string, string>; // TODO: review as it is not used
  format?: (value: T) => unknown;
  parse?: (value: unknown) => T;
  order?: number;
}

export interface DropDownItem<T> {
  value: T;
  display_name: string;
}

export interface DropdownControlInterface<T> extends BaseControlInterface<T> {
  input_type: ControlTypeEnum.Dropdown;
  dropdown_values: Array<DropDownItem<T>>;
  show_dropdown_value: boolean;
}

export interface NumberControlInterface<T> extends BaseControlInterface<T> {
  max?: number;
  min?: number;
}

export interface SelectResourceControlInterface<T> extends BaseControlInterface<T> {
  input_type: ControlTypeEnum.SelectResource;
  resource: string;
  sourceName: string;
  resourceNameSingular: string;
  resourceNamePlural: string;
  hasMultipleAccountSelect: boolean;
}

export interface ArrayControlInterface<T> extends BaseControlInterface<T> {
  input_type: ControlTypeEnum.Array;
  items: Array<ImpexGenericControlInterface<unknown>>;
}

export interface OneofControlInterface<T = unknown> extends BaseControlInterface<T> {
  input_type: ControlTypeEnum.OneOf;
  children: Array<Array<ImpexGenericControlInterface<T>>>;
}

export interface NestedFormInterface<T = unknown> extends BaseControlInterface<T> {
  input_type: ControlTypeEnum.NestedForm;
  children: Array<ImpexGenericControlInterface<T>>;
}

export type ImpexGenericControlInterface<T = unknown> =
  | BaseControlInterface<T>
  | DropdownControlInterface<T>
  | NumberControlInterface<T>
  | SelectResourceControlInterface<T>
  | ArrayControlInterface<T>
  | OneofControlInterface<T>
  | NestedFormInterface<T>;

export enum ControlTypeEnum {
  Number = 'number',
  Checkbox = 'checkbox',
  Text = 'text',
  Date = 'date',
  Password = 'password',
  Dropdown = 'dropdown',
  Array = 'array',
  FileDropper = 'file_dropper',
  SshTunnel = 'ssh_tunnel',
  SelectResource = 'select_resource',
  OneOf = 'one_of',
  Textarea = 'textarea',
  NestedForm = 'nested_form',
}
